import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

export default class FieldGoalGood extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.FieldGoalGood;
    }
}
